import * as React from 'react';

// Utils
import { getStateKey } from '@shopee/mart-search-items-redux';

// Types
import type { SearchParams } from '@shopee/search-common-util';

/**
 * This HOC is meant to reset local state like `offset` in
 * the MartSearchResult component whenever search result key is changed.
 *
 * Otherwise, React won't unmount->remount the component, causing local
 * state like `offset` to be cached even for a different search result.
 */
export const withMartSearchResultKey = (
  Component: React.ComponentType<{ searchParams: SearchParams }>
) => {
  const WithMartSearchResultKeyComponent = (props: {
    searchParams: SearchParams;
  }) => {
    const { searchParams } = props;
    return <Component {...props} key={getStateKey(searchParams)} />;
  };

  return WithMartSearchResultKeyComponent;
};

export function compareSearchParams(
  params1: any,
  params2: any,
  preprocess: (params: any) => any
) {
  return preprocess(params1) === preprocess(params2);
}
